/* ==========================================================================
   Lin & Lore - eigen gedrag bovenop het WK-thema.
   Aangelegd 03-09-2026, laatst gewijzigd 04-09-2026.
   Laadt in de head, dus voor assets/product-page.js.

   VASTE UX-REGELS VOOR DE PRODUCTPAGINA (besloten 04-09-2026).
   Houd deze aan bij elke toekomstige aanpassing:

     1. MAAT KIEZEN  ->  er beweegt niets. Niet de pagina, niet de galerij,
        niet de thumbnail-markering. De bezoeker bepaalt op dat moment alleen
        zijn maat en hoeft niet opnieuw naar de productafbeelding gestuurd.

     2. VARIANT KIEZEN  ->  de galerij toont de bijbehorende foto, maar de
        PAGINA scrolt niet. Wie een variant kiest is al actief met zijn keuze
        en moet niet uit die flow gehaald worden.

     3. THUMBNAIL KLIKKEN  ->  galerij springt direct naar die foto en de
        pagina scrolt naar de productafbeelding. Dat is een expliciete vraag
        om die foto te zien.

   Het thema roept in showMedia() scrollIntoView({block:'nearest'}) aan op een
   galerij-item. Dat verschuift de galerij en sleept de pagina verticaal mee.
   We laten product-page.js met rust en corrigeren het gedrag hier.

   LET OP: gebruik hier nergens behavior:'smooth'. Die wordt niet in elke
   omgeving uitgevoerd, en dan gebeurt er helemaal niets. De paginascroll
   draait op requestAnimationFrame met een vangnet.
   ========================================================================== */
(function () {
  'use strict';

  var VIEWPORT = '[data-gallery-viewport]';
  var frames = {};
  var timers = {};

  /* Staat aan zolang een maatklik wordt afgehandeld. Zie regel 1 hierboven. */
  var onderdrukGalerij = false;

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function stopKanaal(kanaal) {
    if (frames[kanaal]) {
      window.cancelAnimationFrame(frames[kanaal]);
      frames[kanaal] = null;
    }
    if (timers[kanaal]) {
      window.clearTimeout(timers[kanaal]);
      timers[kanaal] = null;
    }
  }

  function animate(kanaal, lees, schrijf, doel) {
    stopKanaal(kanaal);

    var start = lees();
    var verschil = doel - start;

    if (reduceMotion() || document.hidden || Math.abs(verschil) < 2) {
      schrijf(doel);
      return;
    }

    var duur = Math.min(600, Math.max(240, Math.abs(verschil) * 0.55));
    var begin = null;

    function stap(nu) {
      if (begin === null) begin = nu;
      var p = Math.min(1, (nu - begin) / duur);
      schrijf(start + verschil * (1 - Math.pow(1 - p, 3)));
      if (p < 1) {
        frames[kanaal] = window.requestAnimationFrame(stap);
      } else {
        stopKanaal(kanaal);
      }
    }

    frames[kanaal] = window.requestAnimationFrame(stap);

    timers[kanaal] = window.setTimeout(function () {
      stopKanaal(kanaal);
      schrijf(doel);
    }, duur + 250);
  }

  function scrollPaginaNaar(top) {
    animate(
      'pagina',
      function () { return window.pageYOffset; },
      function (v) { window.scrollTo(0, v); },
      Math.max(0, top)
    );
  }

  /* De galerij springt bewust zonder animatie: bij een thumbnail vijf beelden
     verder schoof hij anders langs alles ertussen. De pijltjes van het thema
     houden hun eigen vloeiende beweging; die gaan via scrollBy. */
  function springGalerijNaar(viewport, left) {
    stopKanaal('galerij');
    viewport.scrollLeft = Math.max(0, left);
  }

  var nativeScrollIntoView = Element.prototype.scrollIntoView;

  Element.prototype.scrollIntoView = function () {
    try {
      if (this.hasAttribute && this.hasAttribute('data-media-id') && this.closest) {
        var viewport = this.closest(VIEWPORT);
        if (viewport) {
          /* Regel 1: bij een maatkeuze blijft de galerij staan waar hij staat. */
          if (onderdrukGalerij) return;

          springGalerijNaar(
            viewport,
            this.getBoundingClientRect().left -
              viewport.getBoundingClientRect().left +
              viewport.scrollLeft
          );
          return;
        }
      }
    } catch (error) {
      /* bij twijfel: standaardgedrag */
    }
    return nativeScrollIntoView.apply(this, arguments);
  };

  function stickyHeaderHoogte() {
    var header = document.querySelector('.header');
    if (!header) return 0;
    var positie = window.getComputedStyle(header).position;
    if (positie !== 'sticky' && positie !== 'fixed') return 0;
    return header.getBoundingClientRect().height;
  }

  function scrollNaarGalerij(section) {
    var galerij =
      section.querySelector('[data-product-gallery]') || section.querySelector(VIEWPORT);
    if (!galerij) return;

    scrollPaginaNaar(
      galerij.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHoogte() - 12
    );
  }

  function actieveThumbId(section) {
    var thumb = section.querySelector('[data-gallery-thumb].is-active');
    return thumb ? thumb.getAttribute('data-target-media-id') : null;
  }

  /* Het thema verplaatst de thumbnail-markering ook als wij de galerij bewust
     laten staan. Dan zetten we hem exact terug op wat hij was. Bewust niet op
     basis van geometrie: dat koos bij smalle viewports het verkeerde item. */
  function zetActieveThumb(section, mediaId) {
    var thumbs = section.querySelectorAll('[data-gallery-thumb]');
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle(
        'is-active',
        thumbs[i].getAttribute('data-target-media-id') === mediaId
      );
    }
  }

  /* ---- Kleine productafbeelding in de sticky balk ----
     We hergebruiken de bron van de actieve thumbnail. Die is al een vierkante
     crop van 240px en loopt automatisch mee met kleurkeuze en thumbnailklik. */
  function thumbBron(section) {
    var img = section.querySelector('[data-gallery-thumb].is-active img');
    if (!img) img = section.querySelector('[data-gallery-thumb] img');
    return img ? img.currentSrc || img.src : null;
  }

  function zetStickyAfbeelding(section) {
    var bar = section.querySelector('[data-sticky-bar]');
    if (!bar) return;

    var content = bar.querySelector('.product-sticky-bar__content');
    if (!content) return;

    var img = bar.querySelector('.product-sticky-bar__thumb');
    if (!img) {
      img = document.createElement('img');
      img.className = 'product-sticky-bar__thumb';
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
      img.setAttribute('decoding', 'async');
      content.insertBefore(img, content.firstChild);
    }

    var bron = thumbBron(section);
    if (bron && img.getAttribute('src') !== bron) img.setAttribute('src', bron);
  }

  function volgAfbeelding(section) {
    zetStickyAfbeelding(section);

    var strip = section.querySelector('.product-gallery__thumbs') || section.querySelector(VIEWPORT);
    if (!strip || !window.MutationObserver) return;

    new MutationObserver(function () {
      zetStickyAfbeelding(section);
    }).observe(strip, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var section = target.closest('[data-product-section]');
      if (!section) return;

      /* Regel 3: thumbnail vraagt expliciet om die foto te zien. */
      if (target.closest('[data-gallery-thumb]')) {
        window.setTimeout(function () {
          scrollNaarGalerij(section);
        }, 0);
        return;
      }

      var optieKnop = target.closest('[data-option-button]');
      if (!optieKnop || optieKnop.disabled) return;

      /* Kleuren rendert het thema als polaroid of variant_image; maten en
         andere opties als gewone knop. Alleen bij een beeldoptie mag de
         galerij wisselen (regel 2). Bij een maat blijft alles staan (regel 1). */
      var isBeeldOptie =
        optieKnop.classList.contains('product-info__option-button--polaroid') ||
        optieKnop.classList.contains('product-info__option-button--variant_image');

      onderdrukGalerij = !isBeeldOptie;
      var thumbVoor = onderdrukGalerij ? actieveThumbId(section) : null;

      /* Regel 1 en 2: de pagina scrolt bij geen van beide. Er wordt hier dus
         bewust geen scrollNaarGalerij aangeroepen. */
      window.setTimeout(function () {
        if (onderdrukGalerij && thumbVoor) zetActieveThumb(section, thumbVoor);
        onderdrukGalerij = false;
      }, 0);
    },
    true
  );

  function init() {
    var secties = document.querySelectorAll('[data-product-section]');
    for (var i = 0; i < secties.length; i++) volgAfbeelding(secties[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
